export default __webpack_public_path__ + "static/media/Ponzio.5d53be67.jpg";